import { defineMessages } from 'react-intl';

export default defineMessages({
  addDistribution: 'New distribution',
  emptyMsg: 'No distributions',

  // Columns
  trigger: 'Trigger',
  container: 'Container',
  theme: 'Theme',
  start: 'Start',
  end: 'End',
  portion: 'Portion',
  deviceTypes: 'Device types',

  // Actions
  startNow: 'Start now',
  stop: 'Stop',
  preview: 'Preview',
  copyLink: 'Copy link',
  move: 'Change survey',

  // containers
  popupWindow: 'Popup window',
  modal: 'Modal',
  speechBubble: 'Speech bubble',
  embed: 'Embed',
  newWindow: 'New Window',

  // triggers
  none: 'None',
  existingButton: 'Existing button',
  invisibleLayer: 'Timer ({delay}s)',
  button: 'Button',
});
